// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"cdc0f044","925":"4ba17b90","931":"7068a707"}[chunkId] + ".chunk.css";
};